// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Mint, {Search, Indicator, MessageBox} from 'mint-ui'
import 'mint-ui/lib/style.css'
import router from './router'
import '../static/css/input.css'
import '../static/css/ulli.css'
import axios from 'axios'

Vue.component(Search.name, Search)
Vue.use(Mint)
// alert(process.env.NODE_ENV)
if (process.env.NODE_ENV === 'production') {
  // axios.defaults.baseURL = 'http://yhch.natapp1.cc/kxcapp/kxcyb/front/services'
  axios.defaults.baseURL = 'http://www.kxcyb.cn/kxcapp/front/services'
  // axios.defaults.baseURL = 'http://qzn5ab.natappfree.cc/kxcapp/front/services'
}
// axios.defaults.baseURL = 'http://127.0.0.1:8081/kxcyb/front/services'
// axios.defaults.baseURL = 'http://sns6q8.natappfree.cc/kxcapp/front/services'
let axiosInstance = axios.create({})
axiosInstance.interceptors.request.use(config => {
  if (process.env.NODE_ENV === 'production') {
    config.url = config.url.replace('/api', '')
  }
  Indicator.open({
    text: '加载中...',
    spinnerType: 'fading-circle'
  })
  return config
}, err => {
  setTimeout(() => {
    Indicator.close()
  }, 200)
  alert('请求错误' + JSON.stringify(err))
  return Promise.reject(err)
})
axiosInstance.interceptors.response.use(res => {
  setTimeout(() => {
    Indicator.close()
  }, 200)
  return res
}, err => {
  setTimeout(() => {
    Indicator.close()
  }, 200)
  alert('返回错误' + JSON.stringify(err))
  return Promise.reject(err)
})
Vue.prototype.$http = axiosInstance
Vue.prototype.$axios = axios
Vue.config.productionTip = false

var EventBus = new Vue()
Vue.prototype.$event = EventBus

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data: function () {
    return {
      backRootUrl: '/kxcwx',
      lOpenid: ''
      /* aac001: sessionStorage.getItem('aac001'),
      aac002: sessionStorage.getItem('aac002'),
      aac003: sessionStorage.getItem('aac003'),
      aab001: sessionStorage.getItem('aab001'),
      aac002_1: sessionStorage.getItem('aac002_1') */
    }
  },
  created () {
    var code = localStorage.getItem('weCode')
    var openid = localStorage.getItem('openid')
    if (code && code !== '') {
      if (!openid || openid === '' || openid === null) {
        // 获取openid
        var params = new URLSearchParams()
        params.append('code', code)
        this.$http.post('/api/wechatOpenid', params).then(res => {
          // console.log(res)
          if (res.data.code === '1') {
            // alert('获取openid:' + res.data.openid)
            this.lOpenid = res.data.openid
            localStorage.setItem('openid', this.lOpenid)
            this.updateToken()
          } else {
            localStorage.clear()
            console.log('微信网页授权获取openid失败')
            this.$event.$emit('setHomeWelcome')
            MessageBox.alert('微信网页授权获取openid失败' + res.data.msg)
          }
        })
      } else {
        this.lOpenid = localStorage.getItem('openid')
        this.updateToken()
      }
    } else {
      localStorage.clear()
      this.$event.$emit('setHomeWelcome')
    }
  },
  // created () {
  //   /* if ((/iphone/i).test(navigator.userAgent)) {
  //     alert(WeixinJSBridge)
  //     document.addEventListener('WeixinJSBridgeReady', function onBridgeReady () {
  //       WeixinJSBridge.call('hideToolbar')
  //     })
  //   } */
  //   var code = localStorage.getItem('weCode')
  //   var openid = localStorage.getItem('openid')
  //   // alert('code:' + code + '--openid:' + openid)
  //   if (code && code !== '' && (!openid || openid === '' || openid === null)) {
  //     // 获取openid
  //     var params = new URLSearchParams()
  //     params.append('code', code)
  //     this.$http.post('/api/wechatOpenid', params).then(res => {
  //       // console.log(res)
  //       if (res.data.code === '1') {
  //         // alert('获取openid:' + res.data.openid)
  //         localStorage.setItem('openid', res.data.openid)
  //       } else {
  //         MessageBox.alert('微信网页授权获取openid失败' + res.data.msg)
  //       }
  //     })
  //   }
  //
  //   // 判断登录时间是否超过7天
  //   /* let nowDate = new Date().getTime()
  //   let loginTime = localStorage.getItem('loginTime')
  //   if (loginTime && nowDate - loginTime > 7 * 24 * 60 * 60 * 1000) {
  //     alert('登录过期!')
  //     localStorage.clear()
  //     this.$event.$emit('setHomeWelcome')
  //   } */
  //   // 如果已登录判断访问是否合法
  //   if (localStorage.getItem('aac002')) {
  //     if (!localStorage.getItem('access_token')) {
  //       alert('登录过期!')
  //       localStorage.clear()
  //       this.$event.$emit('setHomeWelcome')
  //     } else {
  //       var checkParams = new URLSearchParams()
  //       checkParams.append('aac002', localStorage.getItem('aac002'))
  //       checkParams.append('access_token', localStorage.getItem('access_token'))
  //       this.$http.post('/api/kxcwx/checkLogin', checkParams).then(res => {
  //         // console.log(res)
  //         if (res.data.code === '-1') {
  //           alert('登录状态失效,请重新登录!')
  //           // localStorage.clear()
  //           localStorage.removeItem('aac001')
  //           this.$event.$emit('setHomeWelcome')
  //         }
  //       })
  //     }
  //     // 更新注册信息中的openid
  //     this.updateOpenid()
  //   }
  // },
  mounted () {
    /* if ((/iphone/i).test(navigator.userAgent)) {
      window.history.pushState({}, 'title', '#')
    } */
  },
  methods: {
    GetQueryString (name) {
      var url = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var newUrl = window.location.search.substr(1).match(url)
      if (newUrl != null) {
        return unescape(newUrl[2])
      } else {
        return false
      }
    },
    // updateOpenid () {
    //   if (localStorage.getItem('openid')) {
    //     var param = new URLSearchParams()
    //     param.append('jybh', 'kxcapp_updateOpenid')
    //     param.append('aac002', localStorage.getItem('aac002'))
    //     param.append('openid', localStorage.getItem('openid'))
    //     this.$http.post('/api/kxcwx/saveDeclare', param).then(res => {
    //       // console.log(res)
    //     })
    //   }
    // },
    updateToken () {
      var param = new URLSearchParams()
      param.append('jybh', 'loadUpdateToken')
      param.append('channel', 'WECHAT')
      param.append('openid', localStorage.getItem('openid'))
      this.$http.post('/api/kxcwx/saveDeclare', param).then(res => {
        if (res.data.code === '1') {
          if (res.data.out.result.lx === '1') {
            localStorage.setItem('aac001', res.data.out.result.aac001)
            localStorage.setItem('aac002', res.data.out.result.aac002)
            localStorage.setItem('aac002_1', this.dealSFZH((res.data.out.result.aac002)))
            localStorage.setItem('aac003', res.data.out.result.aac003)
            localStorage.setItem('aab001', res.data.out.result.aab001)
            localStorage.setItem('aab004', res.data.out.result.aab004)
            localStorage.setItem('yae005', res.data.out.result.aae005)
            localStorage.setItem('access_token', res.data.out.result.token)
            let startTime = new Date().getTime()// 记录何时将值存入缓存，毫秒级
            localStorage.setItem('loginTime', startTime)
            this.$event.$emit('setHomeWelcome')
          } else if (res.data.out.result.lx === '2') {
            localStorage.clear()
            localStorage.setItem('openid', this.lOpenid)
            localStorage.setItem('aac002', res.data.out.result.aac002)
            localStorage.setItem('aac002_1', this.dealSFZH((res.data.out.result.aac002)))
            this.$event.$emit('setHomeWelcome')
          } else {
            alert('登录状态失效,请重新登录!')
            localStorage.clear()
            localStorage.setItem('openid', this.lOpenid)
            this.$event.$emit('setHomeWelcome')
          }
        } else {
          localStorage.clear()
          this.$event.$emit('setHomeWelcome')
        }
      })
    },
    dealSFZH (aac002) {
      if (aac002.length === 18) {
        return aac002.substr(0, 3) + '***********' + aac002.substr(14)
      } else {
        return aac002.substr(0, 3) + '********' + aac002.substr(11)
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js